// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ReplayIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ReplayIcon" ref={forwardedRef} {...props}>
      <path d="m14.5 10-7-4v8zM9 8.585 11.477 10 9 11.415z" />
      <path d="M2 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm1.5 11.5h13v-11h-13z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ReplayIcon = /* @__PURE__ */ Object.assign(ReplayIconComponent, {
  displayName: 'ReplayIcon',
});
